import React from 'react'
import './navbar.css';
import {
  Navbar,
  Nav,
  NavItem
} from 'react-bootstrap/lib';
import { LinkContainer } from 'react-router-bootstrap';

export default (props) => {
  return (
    <Navbar fluid={true}>
      <Navbar.Header>
        <Navbar.Brand>
        </Navbar.Brand>
        <Navbar.Toggle />
      </Navbar.Header>

      <Navbar.Collapse>
        <Nav>
          <LinkContainer to="/" isActive={match => match.isExact}>
            <NavItem>Home</NavItem>
          </LinkContainer>
          <LinkContainer to="/about-us">
            <NavItem>About us</NavItem>
          </LinkContainer>
          <LinkContainer to="/contact">
            <NavItem>Contact</NavItem>
          </LinkContainer>
          <LinkContainer to="/faq">
            <NavItem>FAQ</NavItem>
          </LinkContainer>
          <LinkContainer to="/products">
            <NavItem>Products</NavItem>
          </LinkContainer>
        </Nav>
      </Navbar.Collapse>
    </Navbar>
  )
}



// WEBPACK FOOTER //
// ./src/components/navbar/navbar.js